var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "pdfTemple", staticClass: "app-container" },
    [
      _c(
        "div",
        { ref: "pdfTempForm" },
        [
          _c(
            "BjDivider",
            {
              scopedSlots: _vm._u([
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.exportPage },
                        },
                        [_vm._v(_vm._s(_vm.$t("printText")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.showLog },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseApplyDetail.operationLog")
                            )
                          ),
                        ]
                      ),
                      _c("el-button", { on: { click: _vm.handleClose } }, [
                        _vm._v(_vm._s(_vm.$t("backText"))),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("BusinessPurchaseOrder2.detailTitle")) + " "
              ),
            ]
          ),
          _c("div", { staticClass: "bj-row mt20" }, [
            _c("div", { staticClass: "bj-col bj-col-6" }, [
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.id"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.code)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.Status"))),
                ]),
                _c("div", { staticClass: "bj-form-item-value" }, [
                  _vm._v(_vm._s(_vm.data.status)),
                ]),
              ]),
              _c("div", { staticClass: "bj-form-item" }, [
                _c("div", { staticClass: "bj-form-item-label" }, [
                  _vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Comments"))),
                ]),
                _c("span", { staticClass: "remark-actions" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName:
                            "v-permission:BusinessPurchaseOrderCsgAdminIndexRemarks",
                          arg: "BusinessPurchaseOrderCsgAdminIndexRemarks",
                        },
                      ],
                      staticClass: "link",
                      on: { click: _vm.openEdit },
                    },
                    [_vm._v(_vm._s(_vm.$t("InternalSalesOrderDetails.Modify")))]
                  ),
                  _vm.storeRemarksHistory.length
                    ? _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "permission",
                              rawName:
                                "v-permission:BusinessPurchaseOrderCsgAdminIndexRemarks",
                              arg: "BusinessPurchaseOrderCsgAdminIndexRemarks",
                            },
                          ],
                          staticClass: "link history-link",
                          on: { click: _vm.showHistory },
                        },
                        [
                          _c("i", { staticClass: "el-icon-time" }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("InternalSalesOrderDetails.History")
                              ) +
                                " (" +
                                _vm._s(_vm.storeRemarksHistory.length) +
                                ")"
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
              _c(
                "div",
                { staticClass: "bj-form-item" },
                [
                  _c("BjInput", {
                    attrs: { type: "textarea", rows: 3, disabled: "" },
                    model: {
                      value: _vm.customerRemarks,
                      callback: function ($$v) {
                        _vm.customerRemarks = $$v
                      },
                      expression: "customerRemarks",
                    },
                  }),
                ],
                1
              ),
            ]),
            _c(
              "div",
              {
                staticClass: "bj-col bj-col-6",
                staticStyle: { "border-left": "none" },
              },
              [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.Date"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(
                      _vm._s(_vm._f("timeFilters")(_vm.data.creationDate))
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder3.Item"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.data.purchaseOrderGoods &&
                          _vm.data.purchaseOrderGoods.length
                      )
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "bj-col bj-col-6 no-rb" },
              [
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(_vm._s(_vm.$t("BusinessPurchaseOrder2.Unit"))),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm.data.shippingMethod)),
                  ]),
                ]),
                _vm.data.shippingMethod === "Container"
                  ? [
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c("div", { staticClass: "bj-form-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseOrder2.form.containerId")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(_vm._s(_vm.data.containerId)),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
                _vm.data.shippingMethod !== "Container"
                  ? [
                      _vm.data.shippingMethod === "Pallet"
                        ? _c("div", { staticClass: "bj-form-item" }, [
                            _c("div", { staticClass: "bj-form-item-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("BusinessPurchaseOrder3.PalletQty")
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "bj-form-item-value" }, [
                              _vm._v(_vm._s(_vm.data.palletQty)),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.data.shippingMethod === "Carton"
                        ? _c("div", { staticClass: "bj-form-item" }, [
                            _c("div", { staticClass: "bj-form-item-label" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("BusinessPurchaseOrder3.cartonQty")
                                )
                              ),
                            ]),
                            _c("div", { staticClass: "bj-form-item-value" }, [
                              _vm._v(_vm._s(_vm.data.containerQty)),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c("div", { staticClass: "bj-form-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseOrder2.form.thirdCode")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(_vm._s(_vm.data.thirdCode)),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "bj-col bj-col-6",
                staticStyle: { "border-left": "none" },
              },
              [
                _vm.data.shippingMethod === "Container"
                  ? [
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c("div", { staticClass: "bj-form-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "BusinessPurchaseOrder2.form.containerLength"
                              )
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(_vm._s(_vm.data.containerLength)),
                        ]),
                      ]),
                      _c("div", { staticClass: "bj-form-item" }, [
                        _c("div", { staticClass: "bj-form-item-label" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("BusinessPurchaseOrder2.dropOffMethod")
                            )
                          ),
                        ]),
                        _c("div", { staticClass: "bj-form-item-value" }, [
                          _vm._v(_vm._s(_vm.data.dropOffMethod)),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
                _c("div", { staticClass: "bj-form-item" }, [
                  _c("div", { staticClass: "bj-form-item-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("BusinessPurchaseOrder2.receiveDate"))
                    ),
                  ]),
                  _c("div", { staticClass: "bj-form-item-value" }, [
                    _vm._v(_vm._s(_vm._f("timeFilters")(_vm.data.receiveDate))),
                  ]),
                ]),
              ],
              2
            ),
          ]),
        ],
        1
      ),
      _c(
        "BjDivider",
        [
          _vm._v(
            " " +
              _vm._s(_vm.$t("BusinessPurchaseComponentsPur.information")) +
              " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              !_vm.$store.getters.cusId && _vm.data.hjPullTime
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        "font-weight": "600",
                        color: "#666",
                        "margin-right": "10px",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("BusinessPurchaseComponentsPur.time")) +
                          " : " +
                          _vm._s(_vm._f("timeFilters")(_vm.data.hjPullTime))
                      ),
                    ]
                  )
                : _vm._e(),
              !_vm.$store.getters.cusId && _vm.$route.query.status == "open"
                ? _c(
                    "el-button",
                    {
                      staticClass: "main-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.onBatchconfirmation },
                    },
                    [_vm._v(_vm._s(_vm.$t("Batchconfirmation")))]
                  )
                : _vm._e(),
              !_vm.$store.getters.cusId
                ? _c(
                    "el-button",
                    {
                      staticClass: "main-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.onDownload },
                    },
                    [_vm._v(_vm._s(_vm.$t("downloadText")))]
                  )
                : _vm._e(),
              !_vm.$store.getters.cusId
                ? _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getPONo } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("BusinessPurchaseComponentsPur.getPONo"))
                      ),
                    ]
                  )
                : _vm._e(),
              !_vm.$store.getters.cusId && _vm.$route.query.status === "open"
                ? _c(
                    "el-button",
                    {
                      attrs: { loading: _vm.fixingRecvQty, type: "primary" },
                      on: { click: _vm.fixRecvQty },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessPurchaseComponentsPur.fixRecvQty")
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.exportList } },
                [_vm._v(_vm._s(_vm.$t("printText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      !_vm.$store.getters.cusId
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.data.purchaseOrderGoods,
                border: "",
                script: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.countText"),
                  type: "index",
                  align: "center",
                  "min-width": 60,
                },
              }),
              _c("el-table-column", {
                attrs: { type: "selection", width: "45" },
              }),
              _c("el-table-column", {
                attrs: { label: "SKU", prop: "skuCode", align: "center" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Product"),
                  prop: "skuName",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.ExpectedQty"),
                  prop: "planQty",
                  align: "center",
                  width: "120",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: _vm.$t("BusinessPurchaseOrder3.Received1"),
                    align: "center",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pendingQty",
                      label: _vm.$t("BusinessPurchaseOrder3.PendingQty"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stockedQty",
                      label: _vm.$t("BusinessPurchaseOrder3.StockedQty"),
                      align: "center",
                    },
                  }),
                ],
                1
              ),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BarcodeConfiguration.Barcode"),
                  prop: "barCode",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Expiry"),
                  prop: "expiryDate",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm._v(_vm._s(_vm._f("timeFilters")(row.expiryDate))),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3013125179
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("goodsSku.detail.itemPerCarton"),
                  prop: "qty",
                  align: "center",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Batch"),
                  prop: "batchCode",
                  align: "center",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("goodsPage.Serial"),
                  prop: "needSerialNo",
                  align: "center",
                  width: "80",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                row.needSerialNo === 1
                                  ? _vm.$t("yesText")
                                  : _vm.$t("noText")
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1363851464
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.Downloadstatus"),
                  prop: "isDownloadBarcode",
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                row.isDownloadBarcode === 1
                                  ? _vm.$t("yesText")
                                  : _vm.$t("noText")
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  960191633
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.IsChecked"),
                  prop: "checkStatus",
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                row.checkStatus === 0
                                  ? _vm.$t("BusinessPurchaseOrder3.Not")
                                  : row.checkStatus === 1
                                  ? _vm.$t("BusinessPurchaseOrder3.pass")
                                  : _vm.$t("BusinessPurchaseOrder3.Fail")
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3222067080
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.IsConfirm"),
                  prop: "checkStatus",
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                row.isConfirm === 1
                                  ? _vm.$t("ConfirmedText")
                                  : _vm.$t("UnconfirmedText")
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  19840510
                ),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.operationText"),
                  align: "center",
                  width: "120",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _vm.$route.query.status == "open"
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "delete-btn",
                                  attrs: {
                                    type: "text",
                                    disabled: !!row.isConfirm,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.onConfirm(row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("okText")))]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  778803883
                ),
              }),
            ],
            1
          )
        : _c(
            "el-table",
            {
              attrs: {
                data: _vm.data.purchaseOrderGoods,
                border: "",
                script: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.countText"),
                  type: "index",
                  align: "center",
                  "min-width": 60,
                },
              }),
              _c("el-table-column", {
                attrs: { type: "selection", width: "50" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "SKU",
                  prop: "standardSkuCode",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder2.form.skuName"),
                  prop: "skuName",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder3.ExpectedQty"),
                  prop: "planQty",
                  align: "center",
                  width: "100",
                },
              }),
              _c(
                "el-table-column",
                {
                  attrs: {
                    label: _vm.$t("BusinessPurchaseOrder3.Received1"),
                    align: "center",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pendingQty",
                      label: _vm.$t("BusinessPurchaseOrder3.PendingQty"),
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stockedQty",
                      label: _vm.$t("BusinessPurchaseOrder3.StockedQty"),
                      align: "center",
                    },
                  }),
                ],
                1
              ),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder2.form.batchCode"),
                  prop: "batchCode",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("goodsPage.Serial"),
                  prop: "needSerialNo",
                  align: "center",
                  width: "80",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              row.needSerialNo === 1
                                ? _vm.$t("yesText")
                                : _vm.$t("noText")
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseOrder2.form.expiryDate"),
                  prop: "expiryDate",
                  width: "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(_vm._s(_vm._f("timeFilters")(row.expiryDate))),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseDetailPage.table.length"),
                  prop: "length",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.length) + " cm")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseDetailPage.table.width"),
                  prop: "width",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.width) + " cm")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseDetailPage.table.high"),
                  prop: "height",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.height) + " cm")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseDetailPage.table.Volume"),
                  prop: "volume",
                  align: "center",
                  width: "170",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          _vm._s(
                            (
                              (row.width * row.height * row.length) /
                              1000000
                            ).toFixed(9)
                          ) + " m³"
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("BusinessPurchaseDetailPage.table.Weight"),
                  prop: "weight",
                  align: "center",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_vm._v(_vm._s(row.weight) + " kg")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("InternalSalesOrderDetails.Modify"),
            visible: _vm.isEdit,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isEdit = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "BusinessPurchaseOrder3.warehouseReceiptRemarks"
                    ),
                    prop: "customerRemarks",
                  },
                },
                [
                  _c("BjInput", {
                    attrs: {
                      placeholder: _vm.$t("inputText"),
                      type: "textarea",
                      maxlength: "9999",
                      "show-word-limit": "",
                      clearable: "",
                      autosize: "",
                      rows: "5",
                    },
                    model: {
                      value: _vm.form.customerRemarks,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "customerRemarks", $$v)
                      },
                      expression: "form.customerRemarks",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.editRemarks } },
                [_vm._v(_vm._s(_vm.$t("okText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.$t("InternalSalesOrderDetails.CommentsHistory"),
            visible: _vm.historyVisible,
            direction: "rtl",
            size: "660px",
            "append-to-body": true,
            "wrapper-closable": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.historyVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "remarks-history-drawer" }, [
            _c(
              "div",
              { staticClass: "history-timeline" },
              _vm._l(_vm.storeRemarksHistory, function (item, index) {
                return _c(
                  "div",
                  {
                    key: (item.creationTime || "") + "_" + index,
                    staticClass: "history-item",
                  },
                  [
                    _c("div", {
                      staticClass: "history-dot",
                      class: { active: index === 0 },
                    }),
                    _c("div", [
                      _c(
                        "div",
                        { staticClass: "history-meta" },
                        [
                          _c("span", { staticClass: "history-time" }, [
                            _vm._v(
                              _vm._s(_vm._f("timeFilters")(item.creationTime))
                            ),
                          ]),
                          index === 0
                            ? _c(
                                "el-tag",
                                {
                                  staticClass: "history-current-tag",
                                  attrs: { size: "mini" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "InternalSalesOrderDetails.Current"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "history-remark" }, [
                        _vm._v(_vm._s(item.remark)),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }